import type { Filter } from '../../Entities/Search/SearchFilters/Filter.entity';
import { getModelNameFromId } from '../../Services/Search/Utils/GetModelNameFromId';
import { getVariantNameFromId } from '../../Services/Search/Utils/GetVariantNameFromId';
import { formatMMV } from '../MakeModel/FormatMMV';

export const getSlugParamValueFromFilter = (filter: Filter) => {
  const valStr = Array.isArray(filter.value) ? filter.value[0] : filter.value;
  let output = valStr;

  if (valStr && filter.id === 'model') output = getModelNameFromId(valStr);
  if (valStr && filter.id === 'variant-type') output = getVariantNameFromId(valStr);
  if (valStr && filter.id === 'price__lte') output = `under-${valStr}`;
  if (valStr && filter.id === 'monthly-price__lte') output = `under-${valStr}`;
  if (valStr && filter.id === 'doors') output = `${valStr}-door`;
  if (valStr && filter.id === 'seats') output = `${valStr}-seats`;
  if (valStr && filter.id === 'engine-size__gte') output = `${valStr}l`;
  if (valStr && filter.id === 'page') output = `page-${valStr}`;

  if (output && (filter.id === 'make' || filter.id === 'model' || filter.id === 'variant-type')) {
    return formatMMV(output, 'path');
  }

  return output;
};
